import React from 'react';
import './app-footer.scss';
import logosEuropeus from '../../assets/logos/logos-europeus.png';
import {footerLinks} from './app-footer-utils';

export const AppFooter = () => {
    return (
        <footer>
            <div className="footer-wrapper">
                <a href="/home">
                    <img className="logos-europeus" src={logosEuropeus} alt="Logos europeus" />
                </a>

                <ul>
                    {footerLinks.map((link, i) => (
                        <a href={link.url} key={`link-${i}`}>
                            <li>{link.title}</li>
                        </a>
                    ))}
                </ul>
            </div>
        </footer>
    );
};

